export const CHAT_BUTTON_ID = 'game_editor_chat_button'
export const ADD_PEOPLE_BUTTON_ID = 'game_editor_add_people_button'
export const SHARE_GAME_BUTTON_ID = 'game_editor_share_game_button'
